
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ResidentialPage from "../pages/residential/page";
import CommercialPage from "../pages/commercial/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/residential-renovations",
    element: <ResidentialPage />,
  },
  {
    path: "/commercial-construction",
    element: <CommercialPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
